import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StickyContainer } from 'sp-react-sticky';

import { areFlagsLoaded } from 'selectors/featureFlags';

import LoadingPage from 'components/common/LoadingPage';
import GlobalAlerts from './GlobalAlerts';
import SideGlobalNavigation from './SideGlobalNavigation';

export const SidenavContainer = ({
  children,
  hasLoadedFlags,
}) => {
  // load to make sure not to flash
  if (!hasLoadedFlags) {
    return <LoadingPage />;
  }

  return (
    <div className="app-container">
      <SideGlobalNavigation />

      <StickyContainer className="main-container">
        <GlobalAlerts />

        <div className="content-container">
          { children }
        </div>
      </StickyContainer>
    </div>
  );
};

SidenavContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.element]),
  hasLoadedFlags: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    hasLoadedFlags: areFlagsLoaded(state),
  };
}

export default connect(mapStateToProps)(SidenavContainer);



// WEBPACK FOOTER //
// ./src/components/SidenavContainer.js